module.exports = __webpack_public_path__ + "img/logo_u1992-18.62680376.svg";